
export const filterUsers = (formRequest, boxState, users) => {
    if (!users) {
        return [];
    }

    return users.filter((user) => {
        if (formRequest) {
            if (formRequest.lname && formRequest.lname !== '' && !user.lastName.toLowerCase().startsWith(formRequest.lname.toLowerCase())) {
                return false;
            }
            if (formRequest.uname && formRequest.uname !== '' && !user.username.toLowerCase().startsWith(formRequest.uname.toLowerCase())) {
                return false;
            }
        }

        if (boxState.admin && !user.isAdmin) {
            return false;
        }
        if (boxState.manager && !user.isManager) {
            return false;
        }
        if (boxState.userRole && !user.isUser) {
            return false;
        }
        if (boxState.citepayAdmin && !user.isJsi && !user.isOs) {
            return false;
        }

        return true;
    });
}